module.exports = __webpack_public_path__ + "media/images/svg/notes-97cabaa5e83f43bcb015a99c4abcb012.svg";